import Glide from '@glidejs/glide';
import '@glidejs/glide/dist/css/glide.core.min.css';

function ModuleUsp(container, breakPoint) {
	this.glideElements = {
		container: container
	};

	this.breakPoint = breakPoint;

	this.onResize = this.onResize.bind(this);

	this.glide = new Glide(this.glideElements.container, {
		//autoplay: 3000,
		animationDuration: 500,
		startAt: 1,
		bound: true,
		perView: 5,
		breakpoints: {
			400: {
				perView: 1,
				peek: 70
			},
			500: {
				perView: 1,
				peek: 110
			},
			800: {
				perView: 2,
				peek: 80
			},
			1000: {
				perView: 3,
				peek: 100
			},
			1256: {
				perView: 4,
				peek: 100
			},
		}
	});

	if (window.innerWidth < this.breakPoint) {
		this.activateSlider();
	}

	window.addEventListener('resize', this.onResize);
}

ModuleUsp.prototype.activateSlider = function() {
	if (this.isSliderActive()) {
		return;
	}

	this.addGlideHtml();
	this.glide.mount();
}

ModuleUsp.prototype.deActivateSlider = function() {
	if (!this.isSliderActive()) {
		return;
	}

	this.removeGlideHtml();
	this.glide.destroy();// To do: gives 25% error from glide core
}

ModuleUsp.prototype.isSliderActive = function() {
	return this.glideElements.container.classList.contains('glide');
}

ModuleUsp.prototype.addGlideHtml = function() {
	if (!this.glideElements.trackElement || !this.glideElements.slidesElement || !this.glideElements.slideElements) {
		this.collectGlideHtml();
	}

	this.glideElements.container.classList.add('glide');

	this.glideElements.trackElement.classList.add('glide__track');
	this.glideElements.trackElement.setAttribute('data-glide-el', 'track');

	this.glideElements.slidesElement.classList.add('glide__slides');

	for (let i=0;i<this.glideElements.slideElements.length;i++) {
		this.glideElements.slideElements[i].classList.add('glide__slide');
	}
}

ModuleUsp.prototype.removeGlideHtml = function() {
	if (!this.glideElements.trackElement || !this.glideElements.slidesElement || !this.glideElements.slideElements) {
		this.collectGlideHtml();
	}

	this.glideElements.container.classList.remove('glide');
	this.glideElements.container.classList.remove('glide--swipeable');
	this.glideElements.container.classList.remove('glide--slider');

	this.glideElements.trackElement.classList.remove('glide__track');
	this.glideElements.trackElement.removeAttribute('data-glide-el');

	this.glideElements.slidesElement.classList.remove('glide__slides');

	for (let i=0;i<this.glideElements.slideElements.length;i++) {
		this.glideElements.slideElements[i].classList.remove('glide__slide');
		this.glideElements.slideElements[i].classList.remove('glide__slide--active');
	}
}

ModuleUsp.prototype.collectGlideHtml = function() {
	const container = this.glideElements.container;

	for (let i=0;i<container.childNodes.length;i++) {
		if (container.childNodes[i].nodeType != 1) {
			continue;
		}

		this.glideElements.trackElement = container.childNodes[i];
		break;
	}

	if (!this.glideElements.trackElement) {
		return;
	}

	const trackElement = this.glideElements.trackElement;

	for (let i=0;i<trackElement.childNodes.length;i++) {
		if (trackElement.childNodes[i].nodeType != 1) {
			continue;
		}

		this.glideElements.slidesElement = trackElement.childNodes[i];
		break;
	}

	if (!this.glideElements.slidesElement) {
		return;
	}

	this.glideElements.slideElements = [];
	const slidesElement = this.glideElements.slidesElement;

	for (let i=0;i<slidesElement.childNodes.length;i++) {
		if (slidesElement.childNodes[i].nodeType != 1) {
			continue;
		}

		this.glideElements.slideElements.push(slidesElement.childNodes[i]);
	}
}

ModuleUsp.prototype.onResize = function() {
	if (window.innerWidth < this.breakPoint) {
		this.activateSlider();
	}
	else {
		this.deActivateSlider();
	}
}

export default ModuleUsp;